// Ergomotion Header V1 — interactions
// Predictive search panel (Shopify suggest API), mobile drawer menus, Stamped star formatting,
// icon normalization, and cart badge updates. Fully responsive.

(function () {
  const root = document.querySelector('.ergomotion-header-v1');
  if (!root) return;

  const overlay = root.querySelector('.overlay');
  const headerBar = root.querySelector('.header-v1__main-bar');
  const isDesktop = () => window.innerWidth >= 1291;
  const setExpanded = (el, val) => { if (el) el.setAttribute('aria-expanded', val ? 'true' : 'false'); };

  // Canonical CDN icons fallback
  const ICONS = {
    search: 'https://cdn.shopify.com/s/files/1/0662/9516/9245/files/newsearch-icon.svg?v=1769765905',
    account: 'https://cdn.shopify.com/s/files/1/0662/9516/9245/files/newuser-icon.svg?v=1769765905',
    cart: 'https://cdn.shopify.com/s/files/1/0662/9516/9245/files/newcart-icon.svg?v=1769765906'
  };

  // Helper: safe element lookup by id
  function byId(id, scope = document) {
    try { return scope.getElementById(id); } catch (_) { return null; }
  }

  function stripNonIconChildren(container, { keepBadge }) {
    Array.from(container.childNodes).forEach(n => {
      const isOurIcon =
        n.nodeType === 1 && (n.matches('svg.em-icon') || n.matches('img.em-icon'));
      const isBadge =
        keepBadge &&
        n.nodeType === 1 &&
        (n.matches('[data-cart-count]') || n.classList?.contains('header-v1__cart-badge'));

      if (isOurIcon || isBadge) return;
      if (n.nodeType === 3) { n.textContent = ''; } else { n.remove(); }
    });
  }
  function ensureCartBadge(wrap) {
    let badge = wrap.querySelector('[data-cart-count]');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'header-v1__cart-badge';
      badge.setAttribute('data-cart-count', '');
      wrap.appendChild(badge);
    }
  }
  function insertFallbackIcon(container, type) {
    if (!type || !ICONS[type]) return;
    const img = document.createElement('img');
    img.className = `em-icon em-icon--${type}`;
    img.src = ICONS[type];
    img.width = 24; img.height = 24;
    img.alt = ''; img.setAttribute('aria-hidden', 'true');
    container.insertAdjacentElement('afterbegin', img);
  }
  function normalizeHeaderIcons() {
    const desktopActions = root.querySelector('.header-v1__actions');
    const mobileActions  = root.querySelector('.mobile-drawer__header-actions');
    [desktopActions, mobileActions].forEach(container => {
      if (!container) return;
      const searchBtn = container.querySelector('.header-v1__action-btn--search, a[aria-label="Search"]');
      if (searchBtn) {
        stripNonIconChildren(searchBtn, { keepBadge: false });
        if (!searchBtn.querySelector('.em-icon--search')) insertFallbackIcon(searchBtn, 'search');
      }
      const accountBtn = container.querySelector('a[aria-label="Account"], .header-v1__action-btn--account');
      if (accountBtn) {
        stripNonIconChildren(accountBtn, { keepBadge: false });
        if (!accountBtn.querySelector('.em-icon--account')) insertFallbackIcon(accountBtn, 'account');
      }
      const cartBtn = container.querySelector('.header-v1__cart-btn, #cart-icon-bubble, a[aria-label="Cart"]');
      if (cartBtn) {
        let wrap = cartBtn.querySelector('.header-v1__cart-icon-wrapper');
        if (!wrap) {
          wrap = document.createElement('span');
          wrap.className = 'header-v1__cart-icon-wrapper';
          while (cartBtn.firstChild) wrap.appendChild(cartBtn.firstChild);
          cartBtn.appendChild(wrap);
        }
        stripNonIconChildren(wrap, { keepBadge: true });
        if (!wrap.querySelector('.em-icon--cart')) insertFallbackIcon(wrap, 'cart');
        ensureCartBadge(wrap);
        Array.from(wrap.childNodes).forEach(n => { if (n.nodeType === 3) n.textContent = ''; });
      }
    });
  }

  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const count = cart.item_count || 0;
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
      root.querySelectorAll('#cart-icon-bubble .cart-count, #cart-icon-bubble .cart-count-bubble').forEach(el => {
        el.style.display = 'none'; el.textContent = '';
      });
      normalizeHeaderIcons();
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } })); } catch (_) {}
    } catch (e) {}
  }
  function bindAddToCartRefreshTriggers() {
    const schedule = () => {
      setTimeout(refreshCartCount, 250);
      setTimeout(refreshCartCount, 800);
      setTimeout(refreshCartCount, 1600);
    };
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form) return;
      const action = (form.getAttribute('action') || '').toLowerCase();
      if (action.includes('/cart/add')) schedule();
    }, true);
    document.addEventListener('click', (e) => {
      const sel = [
        'button[name="add"]',
        'button[type="submit"][name="add"]',
        '.product-form__submit',
        '.add-to-cart',
        'button[data-add-to-cart]'
      ];
      if (sel.some(s => e.target.closest(s))) schedule();
    }, true);
  }

  // Stamped formatting helpers
  function injectStampedStarStyle() {
    if (document.getElementById('em-stamped-star-style')) return;
    const css = `
      .ergomotion-header-v1 .product-card__rating-row {
        display: flex; align-items: center; flex-wrap: wrap;
        column-gap: 4px; row-gap: 2px; min-width: 0; max-width: 100%; line-height: 1;
      }
      .ergomotion-header-v1 .product-card__rating-text {
        color: #8A8E91; font-family: "Plus Jakarta Sans", system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, sans-serif;
        font-size: 12px; font-weight: 600; letter-spacing: -0.12px; line-height: 1; margin-left: 0;
        white-space: nowrap; flex: 0 1 auto; min-width: 0;
      }
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-starrating,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-badge {
        display: inline-flex !important; align-items: center; gap: 2px; line-height: 1;
      }
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge {
        padding-right: 0;
        flex: 0 0 auto;
      }
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-fa-star,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-icon-star,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-star-filled,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge svg .stamped-star-filled,
      .ergomotion-header-v1 .product-card__rating-row .spr-icon.spr-icon-star {
        color: #F5A623 !important; fill: #F5A623 !important; stroke: #F5A623 !important; width: 14px !important; height: 14px !important; font-size: 14px !important;
      }
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-fa-star-half-o,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-star-half {
        color: #F5A623 !important; fill: #F5A623 !important; stroke: #F5A623 !important; width: 14px !important; height: 14px !important; font-size: 14px !important;
      }
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-fa-star-o,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-star-empty,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge svg .stamped-star-empty,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge svg path.stamped-star-empty,
      .ergomotion-header-v1 .product-card__rating-row .spr-icon.spr-icon-star-empty {
        color: #D9E2E7 !important; fill: #D9E2E7 !important; stroke: #D9E2E7 !important; width: 14px !important; height: 14px !important; font-size: 14px !important;
      }
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge svg { width: 14px !important; height: 14px !important; font-size: 14px !important; }
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-badge-caption,
      .ergomotion-header-v1 .product-card__rating-row .stamped-product-reviews-badge .stamped-starrating-caption { display: none !important; }
    `;
    const style = document.createElement('style');
    style.id = 'em-stamped-star-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

    function computeRatingAndCountFromBadge(badge) {
    let rating = 0, count = null;
    
    const cap = badge.querySelector('.stamped-badge-caption, .stamped-starrating-caption');
    if (cap) {
      const s = cap.textContent.trim();
      
      // Look for review count FIRST. Stamped renders the label singular ("1 review")
      const mCount = s.match(/(\d+)\s*reviews?\b/i) || s.match(/\((\d+)\)/);
      if (mCount) count = mCount[1];
      
      // Look for rating - must be a decimal number (like 4.5) OR 
      // a number that's NOT the review count and is <= 5
      const ratingMatch = s.match(/(\d+\.\d+)/); // Prefer decimal ratings first
      if (ratingMatch) {
        rating = parseFloat(ratingMatch[1]);
      } else {
        // If no decimal found, look for a standalone number <= 5 that isn't the count
        const allNumbers = s.match(/\b(\d+(?:\.\d+)?)\b/g) || [];
        for (const num of allNumbers) {
          const val = parseFloat(num);
          if (val <= 5 && num !== count) {
            rating = val;
            break;
          }
        }
      }
    }
    
    // Fallback: count stars if no valid rating found from text
    if (!rating || isNaN(rating) || rating === 0) {
      const filled = badge.querySelectorAll('.stamped-fa-star, .stamped-icon-star, .spr-icon-star, .stamped-star-filled, svg .stamped-star-filled').length;
      const half = badge.querySelectorAll('.stamped-fa-star-half-o, .stamped-star-half, svg .stamped-star-half').length;
      rating = filled + 0.5 * half;
      rating = Math.max(0, Math.min(5, rating));
    }
    
    // Fallback for count if not found in caption
    if (!count) {
      const maybe = badge.parentElement?.querySelector('.stamped-badge-link, .stamped-summary, .spr-summary');
      const txt = maybe?.textContent?.trim() || '';
      const mCount2 = txt.match(/(\d+)\s*reviews?\b/i);
      if (mCount2) count = mCount2[1];
    }
    
    return { rating: Number.isFinite(rating) && rating > 0 ? rating.toFixed(1) : null, count };
  }

  function ensureRatingText(row) {
    let textEl = row.querySelector('.product-card__rating-text');
    if (!textEl) {
      textEl = document.createElement('span');
      textEl.className = 'product-card__rating-text';
      const badge = row.querySelector('.stamped-product-reviews-badge');
      if (badge?.nextSibling) row.insertBefore(textEl, badge.nextSibling);
      else row.appendChild(textEl);
    }
    return textEl;
  }
  function formatStampedRatingsInHeader() {
    const rows = root.querySelectorAll('.product-card__rating-row');
    rows.forEach(row => {
      const badge = row.querySelector('.stamped-product-reviews-badge');
      if (!badge) return;
      const textEl = ensureRatingText(row);
      const { rating, count } = computeRatingAndCountFromBadge(badge);
      if (rating && count) textEl.textContent = `${rating} | ${count} ${count === "1" ? "Review" : "Reviews"}`;
      else if (rating && !count) textEl.textContent = `${rating}`;
      else { const t = textEl.textContent.trim(); if (!t) textEl.textContent = ''; }
    });
  }


  // Keep the mega panel inside the viewport, so it never needs to scroll internally
  function sizeMegaPanel(mega) {
    if (!mega) return;
    if (!isDesktop()) { mega.style.maxHeight = ""; return; }
    const anchor = mega.closest(".nav-v1__item") || mega;
    const top = anchor.getBoundingClientRect().bottom;
    mega.style.maxHeight = Math.max(320, window.innerHeight - top - 16) + "px";
  }
  function sizeOpenMegaPanel() {
    sizeMegaPanel(root.querySelector(".nav-v1__item.has-megamenu.is-active .mega-menu"));
  }

  // Overlay placement
  function placeOverlay() {
    if (!overlay || !headerBar) return;
    const rect = headerBar.getBoundingClientRect();
    const top = Math.max(rect.bottom, 0);
    overlay.style.top = top + 'px';
    overlay.style.height = (window.innerHeight - top) + 'px';
    overlay.style.left = 0;
    overlay.style.right = 0;
  }

  // Predictive Search
  const searchPanel = root.querySelector('#em-search');
  const searchInput = searchPanel?.querySelector('#em-search-input');
  const searchForm = searchPanel?.querySelector('.em-search__form');
  const searchClose = searchPanel?.querySelector('.em-search__close');
  const searchResults = searchPanel?.querySelector('#em-search-results');
  const emptyState = searchPanel?.querySelector('.em-search__empty');
  const headerSearchBtns = root.querySelectorAll('.header-v1__action-btn--search');

  function placeSearchPanel() {
    if (!searchPanel || !headerBar) return;
    const rect = headerBar.getBoundingClientRect();
    const top = Math.max(rect.bottom, 0);
    searchPanel.style.top = top + 'px';
    searchPanel.style.left = '0';
    searchPanel.style.right = '0';
  }

  function openSearchPanel() {
    if (!searchPanel) return;
    placeSearchPanel();
    searchPanel.hidden = false;
    searchPanel.classList.add('is-open');
    overlay?.classList.add('is-active');
    headerSearchBtns.forEach(btn => setExpanded(btn, true));
    searchInput?.focus();
    collapseResults();
  }
  function closeSearchPanel() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    searchPanel.hidden = true;
    overlay?.classList.remove('is-active');
    headerSearchBtns.forEach(btn => setExpanded(btn, false));
    collapseResults();
  }
  function collapseResults() {
    if (!searchPanel) return;
    emptyState && emptyState.removeAttribute('hidden');
    searchResults && (searchResults.innerHTML = '');
    searchInput && searchInput.setAttribute('aria-expanded', 'false');
  }

  async function fetchSuggestions(q) {
    const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article,page&resources[limit]=4&resources[options][fields]=title,product_type,variants.title`;
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('suggest failed');
    return res.json();
  }

  function renderSuggestions(data, q) {
    if (!searchResults) return;
    searchResults.innerHTML = '';
    const sections = [];

    // Queries
    if (data?.queries?.length) {
      const frag = document.createElement('div');
      frag.className = 'em-search__group';
      frag.innerHTML = `<div class="em-search__group-title">Search suggestions</div>`;
      const ul = document.createElement('ul');
      ul.className = 'em-search__list';
      data.queries.forEach(item => {
        const li = document.createElement('li');
        li.className = 'em-search__item';
        li.innerHTML = `<a href="/search?q=${encodeURIComponent(item.text)}">${item.text}</a>`;
        ul.appendChild(li);
      });
      frag.appendChild(ul);
      sections.push(frag);
    }

    // Products
    if (data?.resources?.results?.products?.length) {
      const frag = document.createElement('div');
      frag.className = 'em-search__group';
      frag.innerHTML = `<div class="em-search__group-title">Products</div>`;
      const ul = document.createElement('ul');
      ul.className = 'em-search__list';
      data.resources.results.products.forEach(p => {
        const li = document.createElement('li');
        li.className = 'em-search__item';
        const img = p.image ? `<img src="${p.image}" alt="${p.title}" loading="lazy"/>` : '';
        li.innerHTML = `<a href="${p.url}">${img}<span class="em-search__item-text">${p.title}</span></a>`;
        ul.appendChild(li);
      });
      frag.appendChild(ul);
      sections.push(frag);
    }

    // Collections
    if (data?.resources?.results?.collections?.length) {
      const frag = document.createElement('div');
      frag.className = 'em-search__group';
      frag.innerHTML = `<div class="em-search__group-title">Collections</div>`;
      const ul = document.createElement('ul');
      ul.className = 'em-search__list';
      data.resources.results.collections.forEach(c => {
        const li = document.createElement('li');
        li.className = 'em-search__item';
        const img = c.image ? `<img src="${c.image}" alt="${c.title}" loading="lazy"/>` : '';
        li.innerHTML = `<a href="${c.url}">${img}<span class="em-search__item-text">${c.title}</span></a>`;
        ul.appendChild(li);
      });
      frag.appendChild(ul);
      sections.push(frag);
    }

    // Articles/Pages
    const pages = [...(data?.resources?.results?.articles || []), ...(data?.resources?.results?.pages || [])];
    if (pages.length) {
      const frag = document.createElement('div');
      frag.className = 'em-search__group';
      frag.innerHTML = `<div class="em-search__group-title">Content</div>`;
      const ul = document.createElement('ul');
      ul.className = 'em-search__list';
      pages.forEach(pg => {
        const li = document.createElement('li');
        li.className = 'em-search__item';
        li.innerHTML = `<a href="${pg.url}"><span class="em-search__item-text">${pg.title}</span></a>`;
        ul.appendChild(li);
      });
      frag.appendChild(ul);
      sections.push(frag);
    }

    if (!sections.length) {
      const none = document.createElement('div');
      none.className = 'em-search__empty';
      none.textContent = `No results for "${q}"`;
      searchResults.appendChild(none);
    } else {
      sections.forEach(s => searchResults.appendChild(s));
    }

    emptyState && emptyState.setAttribute('hidden', '');
    searchInput && searchInput.setAttribute('aria-expanded', 'true');
  }

  // Search events
  let searchDebounce;
  headerSearchBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openSearchPanel();
    });
  });
  searchClose?.addEventListener('click', closeSearchPanel);
  overlay?.addEventListener('click', () => {
    if (searchPanel && !searchPanel.hidden) closeSearchPanel();
  });

  searchInput?.addEventListener('input', (e) => {
    const q = (e.target.value || '').trim();
    clearTimeout(searchDebounce);
    if (!q) { collapseResults(); return; }
    searchDebounce = setTimeout(async () => {
      try {
        const data = await fetchSuggestions(q);
        renderSuggestions(data, q);
      } catch (_) {
        searchResults.innerHTML = `<div class="em-search__empty">View all results for "${q}"</div>`;
        emptyState && emptyState.setAttribute('hidden', '');
        searchInput && searchInput.setAttribute('aria-expanded', 'true');
      }
    }, 250);
  });
  searchForm?.addEventListener('submit', () => { closeSearchPanel(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (searchPanel && !searchPanel.hidden) { closeSearchPanel(); return; }
      closeAll();
      const d = root.querySelector('#mobile-drawer');
      if (d?.classList.contains('is-open')) closeDrawer();
      overlay?.classList.remove('is-active');
    }
  });

  // Desktop/tablet menus
  const items = root.querySelectorAll('.nav-v1__item.has-megamenu, .nav-v1__item.has-dropdown');

  function closeAll(except) {
    items.forEach(i => {
      if (i !== except) {
        i.classList.remove('is-active');
        const link = i.querySelector('.nav-v1__link[aria-haspopup]');
        setExpanded(link, false);
      }
    });
    if (!except && overlay) overlay.classList.remove('is-active');
  }

  function openItem(item) {
    const link = item.querySelector('.nav-v1__link[aria-haspopup]');
    closeAll(item);
    item.classList.add('is-active');
    setExpanded(link, true);
    if (item.classList.contains('has-megamenu')) {
      placeOverlay();
      overlay?.classList.add('is-active');
      const mega = item.querySelector('.mega-menu');
      sizeMegaPanel(mega);

      hydrateStampedWithin(mega || root);
      waitForStamped(() => hydrateStampedWithin(mega || root));
      setTimeout(() => hydrateStampedWithin(mega || root), 200);
      setTimeout(() => hydrateStampedWithin(mega || root), 800);
      setTimeout(() => hydrateStampedWithin(mega || root), 1600);

      formatStampedRatingsInHeader();
      setTimeout(formatStampedRatingsInHeader, 200);
      setTimeout(formatStampedRatingsInHeader, 800);
      setTimeout(formatStampedRatingsInHeader, 1600);
    }
  }
  function closeItem(item) {
    const link = item.querySelector('.nav-v1__link[aria-haspopup]');
    item.classList.remove('is-active');
    setExpanded(link, false);
    overlay?.classList.remove('is-active');
  }
  items.forEach(item => {
    const link = item.querySelector('.nav-v1__link');
    const isMega = item.classList.contains('has-megamenu');

    item.addEventListener('mouseenter', () => { if (isDesktop()) openItem(item); });
    if (!isMega) {
      item.addEventListener('mouseleave', () => { if (isDesktop()) closeItem(item); });
    }
    link?.addEventListener('click', (e) => {
      if (isDesktop() && (item.classList.contains('has-dropdown') || isMega)) {
        e.preventDefault();
        item.classList.contains('is-active') ? closeItem(item) : openItem(item);
      }
    });
    link?.addEventListener('keydown', (e) => {
      if (isDesktop() && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        item.classList.contains('is-active') ? closeItem(item) : openItem(item);
      }
    });
  });
  document.addEventListener('click', (e) => {
    const openEl = root.querySelector('.nav-v1__item.is-active');
    if (!openEl) return;
    if (openEl.contains(e.target)) return;
    closeAll();
  });

  // Mobile drawer
  const hamburger = root.querySelector('.header-v1__hamburger');
  const drawer = root.querySelector('#mobile-drawer');
  const closeBtn = drawer?.querySelector('.mobile-drawer__close-btn');
  const mainPanel = drawer?.querySelector('.mobile-drawer__panel--main');
  const submenuPanels = drawer?.querySelectorAll('.mobile-drawer__panel--submenu') || [];
  let focusables = [], firstFocus = null, lastFocus = null;

  function trapFocus(e) {
    if (e.key !== 'Tab' || !focusables.length) return;
    if (e.shiftKey && document.activeElement === firstFocus) { lastFocus.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === lastFocus) { firstFocus.focus(); e.preventDefault(); }
  }
  function lockScroll() { document.body.style.overflow = 'hidden'; }
  function unlockScroll() { document.body.style.overflow = ''; } 

  function collapseGroupLists(container) {
    try {
      container.querySelectorAll('.mobile-drawer__collapse-toggle').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      container.querySelectorAll('.mobile-drawer__group-list, .mobile-drawer__group-sublist, .mobile-bottom-menu__sublist').forEach(list => {
        list.setAttribute('hidden', '');
      });
    } catch (_) {}
  }

  function showPanel(panel) {
    submenuPanels.forEach(p => { if (p !== panel) { p.classList.remove('is-active'); p.setAttribute('hidden', ''); } });
    panel?.removeAttribute('hidden');
    panel?.classList.add('is-active');
    collapseGroupLists(panel);
    formatStampedRatingsInHeader();
  }
  function showMain() {
    submenuPanels.forEach(p => { p.classList.remove('is-active'); p.setAttribute('hidden', ''); });
    mainPanel?.classList.add('is-active');
    mainPanel?.removeAttribute('hidden');
    collapseGroupLists(mainPanel);
    formatStampedRatingsInHeader();
  }

  function openDrawer() {
    if (!drawer || !hamburger) return;
    drawer.hidden = false;
    requestAnimationFrame(() => {
      showMain();

      drawer.classList.add('is-open');
      overlay?.classList.add('is-active');
      placeOverlay();
      hamburger.setAttribute('aria-expanded', 'true');
      lockScroll();

      focusables = Array.from(drawer.querySelectorAll('a[href], button')).filter(el => !el.closest('[hidden]'));
      firstFocus = focusables[0];
      lastFocus = focusables[focusables.length - 1];
      firstFocus?.focus();
      drawer.addEventListener('keydown', trapFocus);

      normalizeHeaderIcons();
      refreshCartCount();
      formatStampedRatingsInHeader();
      setTimeout(formatStampedRatingsInHeader, 200);
    });
  }
  function closeDrawer() {
    if (!drawer || !hamburger) return;
    drawer.classList.remove('is-open');
    overlay?.classList.remove('is-active');
    hamburger.setAttribute('aria-expanded', 'false');
    drawer.removeEventListener('keydown', trapFocus);
    unlockScroll();
    setTimeout(() => {
      showMain();
      drawer.hidden = true;
      hamburger.focus();
    }, 200);
  }
  hamburger?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', () => {
    if (searchPanel && !searchPanel.hidden) { closeSearchPanel(); return; }
    closeDrawer(); closeAll();
  });

  // Open first/second-level menu panels
  drawer?.querySelectorAll('.mobile-drawer__nav-link.has-submenu').forEach(tog => {
    tog.addEventListener('click', () => {
      const target = tog.dataset.target;
      const panel = drawer.querySelector(`.mobile-drawer__panel--submenu[data-panel="${target}"]`);
      if (panel) {
        mainPanel?.classList.remove('is-active');
        mainPanel?.setAttribute('hidden', '');
        showPanel(panel);
        panel.querySelector('a, button')?.focus();
      }
    });
  });

  // Back buttons
  drawer?.querySelectorAll('.mobile-drawer__back-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const parentPanel = btn.closest('.mobile-drawer__panel--submenu');
      if (!parentPanel) return;
      const isFirstLevel = Array.from(drawer.querySelectorAll('.mobile-drawer__panel--submenu'))
        .some(p => p === parentPanel && p.dataset.panel && !p.dataset.panel.includes('--'));
      parentPanel.classList.remove('is-active');
      parentPanel.setAttribute('hidden', '');
      if (isFirstLevel) {
        showMain();
        drawer.querySelector(`.mobile-drawer__nav-link[data-target="${parentPanel.dataset.panel}"]`)?.focus();
      } else {
        const key = parentPanel.dataset.panel.split('--')[0];
        const firstPanel = drawer.querySelector(`.mobile-drawer__panel--submenu[data-panel="${key}"]`);
        if (firstPanel) {
          showPanel(firstPanel);
          drawer.querySelector(`.mobile-drawer__nav-link[data-target="${parentPanel.dataset.panel}"]`)?.focus();
        } else {
          showMain();
        }
      }
    });
  });

  // COLLAPSIBLE GROUPS (Shop by Size / Shop by Feature) and Bottom mobile menu
  // Use robust getElementById-based lookup to avoid CSS.escape issues on some mobile browsers.

  // Size/Feature group header toggle
  drawer?.addEventListener('click', (e) => {
    const btn = e.target.closest('.mobile-drawer__collapse-toggle');
    if (!btn) return;
    const id = btn.getAttribute('aria-controls');
    const list = id && byId(id, drawer);
    if (!list) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    expanded ? list.setAttribute('hidden', '') : list.removeAttribute('hidden');
    e.stopPropagation();
  });

  // Keyboard support for Size/Feature collapse toggles
  drawer?.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const btn = e.target.closest('.mobile-drawer__collapse-toggle');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('aria-controls');
    const list = id && byId(id, drawer);
    if (!list) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    expanded ? list.setAttribute('hidden', '') : list.removeAttribute('hidden');
  });

  // Nested sublists inside Size/Feature
  drawer?.addEventListener('click', (e) => {
    const btn = e.target.closest('.mobile-drawer__group-item--has-submenu');
    if (!btn) return;
    const id = btn.dataset.target;
    const list = id && byId(id, drawer);
    if (!list) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    expanded ? list.setAttribute('hidden', '') : list.removeAttribute('hidden');
    e.stopPropagation();
  });

  // Bottom mobile menu expand/collapse
  drawer?.addEventListener('click', (e) => {
    const btn = e.target.closest('.mobile-bottom-menu__toggle');
    if (!btn) return;
    const id = btn.dataset.target;
    const list = id && byId(id, drawer);
    if (!list) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    expanded ? list.setAttribute('hidden', '') : list.removeAttribute('hidden');
    e.stopPropagation();
  });

  // Init
  placeOverlay();
  placeSearchPanel();
  normalizeHeaderIcons();
  refreshCartCount();

  injectStampedStarStyle();
  hydrateStampedWithin(root);
  waitForStamped(() => { hydrateStampedWithin(root); formatStampedRatingsInHeader(); });
  setTimeout(() => { hydrateStampedWithin(root); formatStampedRatingsInHeader(); }, 250);

  window.addEventListener('resize', () => {
    placeOverlay();
    placeSearchPanel();
    sizeOpenMegaPanel();
    const d = root.querySelector('#mobile-drawer');
    if (isDesktop() && d?.classList.contains('is-open')) closeDrawer();
  });
  window.addEventListener('scroll', () => { sizeOpenMegaPanel(); }, { passive: true });
  document.addEventListener('stamped:dom:changed', () => {
    formatStampedRatingsInHeader();
    setTimeout(formatStampedRatingsInHeader, 50);
  });

  // Observers
  const iconObserver = new MutationObserver(() => normalizeHeaderIcons());
  iconObserver.observe(root, { childList: true, subtree: true });

  // Stamped hydration helpers
  function hydrateStampedWithin(container) {
    try {
      const fn = window.StampedFn;
      if (fn) ['reload', 'refresh', 'loadBadges', 'updateBadges', 'reloadBadges'].forEach(m => { if (typeof fn[m] === 'function') fn[m](); });
      const widget = window.StampedWidget || (window.Stamped && window.Stamped.Widget);
      if (widget && typeof widget.refresh === 'function') widget.refresh();
      (container || document).dispatchEvent(new Event('stamped:dom:changed'));
    } catch (e) {}
  }
  function waitForStamped(cb, timeout = 8000) {
    const start = Date.now();
    const iv = setInterval(() => {
      const ready = !!(window.StampedFn || window.StampedWidget || (window.Stamped && window.Stamped.Widget));
      if (ready) { clearInterval(iv); try { cb(); } catch (_) {} }
      else if (Date.now() - start > timeout) { clearInterval(iv); }
    }, 300);
  }

  bindAddToCartRefreshTriggers();
})();